import { Component, ViewChild, ChangeDetectorRef, OnInit, OnDestroy, NgZone } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common'; // Importar DatePipe
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { Subscription, Observable } from 'rxjs';
import { switchMap, tap, delay } from 'rxjs/operators';
import { PaginatorIntl } from 'src/app/paginator-intl';
import { ProgramacionMasivaService } from 'src/app/services/programacion-masiva.service';
import { TimeService } from 'src/app/services/time.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTable } from '@angular/material/table';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-carga-masiva',
  standalone: true,
  imports: [
    CommonModule, 
    MatCardModule, 
    MatButtonModule, 
    MatIconModule, 
    MatTableModule,
    MatPaginatorModule, 
    MatSortModule, 
    MatFormFieldModule, 
    MatInputModule, 
    MatSnackBarModule,
    MatProgressSpinnerModule, 
    FormsModule,
    MatTooltipModule,
    MatSlideToggleModule
  ],
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.scss'],
  providers: [
    { provide: MatPaginatorIntl, useClass: PaginatorIntl },
    DatePipe // Proveer DatePipe para usarlo en el template
  ]
})
export class CargaMasivaComponent implements OnInit, OnDestroy {
  fileName: string = '';
  loading: boolean = false;
  processing: boolean = false; // Para el botón de procesar  
  tempSuccessMessage: string = ''; // Propiedad auxiliar temporal para el refresh de la tabla.
  
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();

  // --- Propiedades para la nueva tabla ---
  displayedColumnsDiaria: string[] = [
    'id', 
    'nombre_cliente', 
    'nombre_local', 
    'rut_tecnico1', 
    'mes_facturacion',
    'estado_procesamiento', 
    'mensaje_error', 
    'actions'
  ];
  dataSourceDiaria = new MatTableDataSource<any>();
  editingRow: any = null; // Fila actualmente en edición

  @ViewChild('tablaResultados') table: MatTable<any> | undefined;

  // --- Propiedades para el reloj en tiempo real ---
  serverTime: Date | null = null;
  private timeSubscription: Subscription | undefined;
  private timerId: any;
  
  procesarHoy: boolean = false;

  @ViewChild(MatPaginator) set paginator(paginator: MatPaginator) {
    if (paginator) { this.dataSource.paginator = paginator; }
  }
  @ViewChild(MatSort) set sort(sort: MatSort) {
    if (sort) { this.dataSource.sort = sort; }
  }

  constructor(
    private programacionMasivaService: ProgramacionMasivaService,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private timeService: TimeService,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.startTimeSync();
    this.loadProgramacionDiaria();
  }

  ngOnDestroy(): void {
    this.timeSubscription?.unsubscribe();
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }
  
  /**
   * Carga los datos de la tabla intermedia desde la BD.
   * Se llama al iniciar y después de cada operación importante.
   */
  loadProgramacionDiaria(): Observable<any> {
    this.loading = true;
    // Guardamos la petición en una constante
    const request$ = this.programacionMasivaService.getProgramacionParaManana(this.procesarHoy).pipe(
      tap({
        next: (data: any[]) => {
          this.dataSourceDiaria.data = data;
          this.loading = false;
          this.cdr.detectChanges(); // Forzamos el pintado de la tabla (Verde)
        },
        error: () => {
          const fechaTxt = this.procesarHoy ? 'hoy' : 'mañana';
          this.snackBar.open(`Error al cargar la programación de ${fechaTxt}.`, 'Cerrar', { duration: 3000 });
          this.loading = false;
          this.cdr.detectChanges();
        }
      })
    );

    // Nos suscribimos inmediatamente para que funcione como siempre al cargar la página
    request$.subscribe();

    // Retornamos el observable para usarlo en ejecutarProceso
    return request$;
  }
  
  // Este método se ejecutará cada vez que se mueva el switch en el HTML
  onSwitchChange(): void {
    // Limpiamos la tabla actual para dar feedback visual de carga
    this.dataSourceDiaria.data = []; 
    this.loadProgramacionDiaria();
  }

  ejecutarProceso(): void {
    if (this.loading) return;

    const fechaTexto = this.procesarHoy ? 'HOY MISMO' : 'MAÑANA';
  
    Swal.fire({
      title: '¿Confirmar ejecución?',
      text: `Se procesarán las visitas pendientes programadas para ${fechaTexto}.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, ejecutar',
      cancelButtonText: 'Cancelar'
    }).then((result: any) => {
      if (result.isConfirmed) {
        
        // 1. Encendemos loading
        this.loading = true; 
        this.dataSourceDiaria.data = []; // Vaciamos la tabla visualmente (Feedback inmediato)
        this.cdr.detectChanges();

        this.programacionMasivaService.procesarProgramacion(this.procesarHoy).pipe(
          
          // 2. TRUCO DE LA BASE DE DATOS: 
          // Esperamos 1 segundo ENTERO antes de pedir los datos nuevos.
          // Esto da tiempo a que la transacción del backend se confirme al 100%.
          delay(1000), 

          switchMap((res: any) => {
             this.tempSuccessMessage = res.message || 'Proceso completado correctamente';
             return this.programacionMasivaService.getProgramacionParaManana(this.procesarHoy);
          })
        ).subscribe({
          next: (data: any[]) => {
            // 3. ENTRAR A LA ZONA DE ANGULAR
            // Aseguramos que esto corra dentro del ciclo de detección de cambios
            this.ngZone.run(() => {
                console.log('Datos Nucleares Recibidos:', data);

                // 4. RECREACIÓN TOTAL DEL DATASOURCE
                // En lugar de actualizar .data, creamos uno nuevo.
                this.dataSourceDiaria = new MatTableDataSource(data);
                
                this.loading = false;
                this.cdr.detectChanges(); // Forzar pintado

                // Si tenemos referencia a la tabla, le decimos que renderice
                if (this.table) this.table.renderRows();

                // 5. Alerta final
                Swal.fire({
                    title: 'Éxito',
                    text: this.tempSuccessMessage,
                    icon: 'success',
                    timer: 3000 // Se cierra sola a los 3 seg
                });
            });
          },
          error: (err: any) => {
            this.ngZone.run(() => {
                this.loading = false;
                this.loadProgramacionDiaria(); // Intentar recuperar estado anterior
                Swal.fire('Error', 'Hubo un problema al ejecutar el proceso.', 'error');
            });
          }
        });
      }
    });
  }

  startEdit(row: any): void {
    this.editingRow = { ...row }; // Clonar la fila para poder cancelar
  }

  cancelEdit(): void {
    this.editingRow = null;
  }

  saveEdit(): void {
    if (!this.editingRow) return;
    
    this.loading = true;
    this.programacionMasivaService.updateProgramacion(this.editingRow.id, this.editingRow).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado correctamente.', 'Cerrar', { duration: 3000 });
        this.editingRow = null;
        this.loading = false;
        this.loadProgramacionDiaria(); // Recargar los datos tras editar
      },
      error: () => {
        this.snackBar.open('Error al actualizar el registro.', 'Cerrar', { duration: 3000 });
        this.loading = false;
      }
    });
  }

  /**
   * Inicia la sincronización del reloj.
   * Primero obtiene la hora del servidor y luego la actualiza cada segundo.
   */
    private startTimeSync(): void {
    this.timeSubscription = this.timeService.getServerTime().subscribe({
      next: (response: any) => {
        this.serverTime = new Date(response.serverTime);

        this.ngZone.runOutsideAngular(() => {
          this.timerId = setInterval(() => {
            // Esto elimina el error de TypeScript y previene fallos.            
            this.ngZone.run(() => {
              if(this.serverTime)
                this.serverTime = new Date(this.serverTime.getTime() + 1000);
            });
          }, 1000);
        });
      },
      error: () => {
        this.snackBar.open('No se pudo obtener la hora del servidor.', 'Cerrar', { duration: 3000 });
      }
    });
  }
  

   onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    
    this.loading = true;
    this.fileName = file.name;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        // Leemos el excel, pero ya no intentamos formatear la fecha aquí.
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json<any>(worksheet);

        if (data.length > 0) {
          this.displayedColumns = Object.keys(data[0]);
          this.dataSource.data = data;
        } else {
          this.snackBar.open('El archivo Excel está vacío.', 'Cerrar', { duration: 3000 });
        }
      } catch (error) {
        this.snackBar.open('Error al procesar el archivo Excel.', 'Cerrar', { duration: 3000 });
        this.resetView();
      } finally {
        this.loading = false;        
        this.cdr.detectChanges();
      }
    };
    reader.onerror = () => {
      this.loading = false;
      this.snackBar.open('Error al leer el archivo.', 'Cerrar', { duration: 3000 });
      this.cdr.detectChanges();
    };
    reader.readAsBinaryString(file);
  }
  
  enviarDatos() {
    this.loading = true;
    this.programacionMasivaService.guardarCarga(this.dataSource.data).subscribe({
      next: (response: any) => {
        this.snackBar.open(`Datos enviados. ${response.registrosRecibidos} registros serán procesados.`, 'Cerrar', { duration: 5000 });
        this.resetView(); // Limpia la vista previa del Excel        
        this.loadProgramacionDiaria();
        this.cdr.detectChanges();
      },
      error: (error: any) => {        
        console.error('Error detallado del backend:', error); 

        // 1. Determinar el mensaje de error
        let errorMessage: string;
        if (error.error && error.error.message) {
          // Caso 1: Error 400 (Bad Request) con JSON, como el de tu captura
          errorMessage = error.error.message;
        } else if (error.message) {
          // Caso 2: Error genérico de HTTP o red
          errorMessage = error.message;
        } else {
          // Caso 3: Fallback por si el error no tiene un formato esperado
          errorMessage = 'Ocurrió un error desconocido al procesar el archivo.';
        }

        // 2. Mostrar el Swal en lugar del snackbar
        Swal.fire({
          icon: 'error',
          title: 'Error en la Carga',
          // Usamos 'html' para formatear mejor el mensaje
          html: `<p>No se pudieron enviar los datos. El servidor reportó el siguiente error:</p>
                 <strong style="color: #d33; white-space: pre-wrap;">${errorMessage}</strong>`,
          confirmButtonText: 'Entendido'
        });

        // 3. Asegurarse de detener el loading
        this.loading = false; 
        this.cdr.detectChanges();        
      },
      complete: () => {
      
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }  
   
  resetView(): void {
    this.fileName = '';
    this.dataSource.data = [];
    this.displayedColumns = [];
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if(fileInput) fileInput.value = '';
  }

  downloadSampleExcel(): void {
    const filename = 'plantilla_carga_masiva.xlsx';
    const filePath = `assets/templates/${filename}`;
    
    this.http.get(filePath, { responseType: 'blob' }).subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(url);
        },
        error: () => this.snackBar.open('Error al descargar la plantilla.', 'Cerrar', { duration: 3000 })
    });
  }
  
}